// useChessLearnTour.js - Fixed to match MainPage pattern exactly
import { useTour } from './TourProvider';
import { useTranslation } from 'react-i18next';

// Tour configuration for Chess Learn Page with positioning options (matching MainPage structure)
export const chessLearnTourSteps = [
  {
    selector: '.chess-board-container',
    title: 'chess_learn_welcome_title',
    content: 'chess_learn_welcome_content',
    additionalInfo: 'chess_learn_welcome_additional',
    positioning: {
      position: 'above',
      offset: 20,
      align: 'center'
    }
  },
  {
    selector: '.chess-board-container',
    title: 'chess_learn_board_title',
    content: 'chess_learn_board_content',
    additionalInfo: 'chess_learn_board_additional',
    positioning: {
      position: 'right',
      offset: 30,
      align: 'center'
    }
  },
  {
    selector: '[data-tour="best-move"]',
    title: 'chess_learn_best_title',
    content: 'chess_learn_best_content',
    additionalInfo: 'chess_learn_best_additional',
    positioning: {
      position: 'above',
      offset: 15,
      align: 'center'
    }
  },
  {
    selector: '[data-tour="extra-controls"]',
    title: 'chess_learn_extra_title',
    content: 'chess_learn_extra_content',
    additionalInfo: 'chess_learn_extra_additional',
    positioning: {
      position: 'above',
      offset: 15,
      align: 'center'
    }
  },
  {
  selector: '[data-tour="control-panel"]',
  title: 'chess_learn_control_panle_title',
  content: 'chess_learn_control_panle_content',
  additionalInfo: 'chess_learn_control_panle_additional',
  positioning: {
    position: 'above',
    offset: 15,
    align: 'center'
  }
},
  {
    selector: '.chess-board-container',
    title: 'chess_learn_ready_title',
    content: 'chess_learn_ready_content',
    additionalInfo: 'chess_learn_ready_additional',
    positioning: {
      position: 'below',
      offset: 30,
      align: 'center'
    }
  }
];

// Hook for Chess Learn Page tour (EXACTLY matching MainPage pattern)
export const useChessLearnTour = () => {
  const { startTour, shouldShowTour, resetTour } = useTour();
  const { t } = useTranslation();

  const tourName = 'chessLearn'; // Simple name like MainPage

  const startChessLearnTour = () => {
    //console.log('🎓 Starting Chess Learn tour with correct pattern...');
    
    // Map steps with translations (EXACTLY like MainPage)
    const steps = chessLearnTourSteps.map(step => ({
      ...step,
      title: t(step.title) || step.title,
      content: t(step.content) || step.content,
      additionalInfo: step.additionalInfo ? (t(step.additionalInfo) || step.additionalInfo) : undefined,
      // Keep original positioning config
      positioning: step.positioning
    }));

    // Call startTour with TWO parameters like MainPage (this is the key fix!)
    startTour(tourName, steps);
  };

  const shouldShowChessLearnTour = () => {
    return shouldShowTour(tourName);
  };

  const resetChessLearnTour = () => {
    resetTour(tourName);
  };

  return {
    startChessLearnTour,
    shouldShowTour: shouldShowChessLearnTour,
    resetTour: resetChessLearnTour,
    tourName,
  };
};